export default [
  'ResourceService',
  class CurrencyAPISerice {
    constructor (resourceService) {
      this._resourceService = resourceService;
      this._API_BASE = '/currency';
    }

    getCurrencyInfo (country) {
      let query = '';

      if(country) query += `?country=${country}`;

      return this._resourceService.get(`${this._API_BASE}${query}`);
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/api-services/currency-service.js